import { RefObject } from 'react';
import { useDocsLoader } from './useDocsLoader';
import { CommunicationMessageEvents } from '../../interfaces/message-events';
import { useDocsUrl } from './useDocsUrl';
import { useIframeMessage } from './useIframeMessage';
import { DocWindowMessage } from '../interfaces/setup-guide-tracking';
import { getDocsConfig } from '../../../shared/utils/config';

export function useDocs({
  iframeRef,
  docLink,
  areTabsRendered = false,
  queryParams,
  onMessage,
  onIframeLoadError,
  onIframeLoadSuccess,
  loadMessage,
  loadedMessage
}: {
  iframeRef: RefObject<HTMLIFrameElement>;
  docLink: string;
  areTabsRendered?: boolean;
  queryParams?: Record<string, string>;
  onMessage?: (message: DocWindowMessage) => void;
  onIframeLoadError: VoidFunction;
  onIframeLoadSuccess: VoidFunction;
  loadMessage: CommunicationMessageEvents;
  loadedMessage: CommunicationMessageEvents;
}) {
  const [iframeSourceURL, rebuildIframeSourceURL] = useDocsUrl({
    docLink,
    areTabsRendered,
    queryParams
  });

  const onMessageFromIframe = (e: DocWindowMessage) => {
    onLoadingMessageFromIframe(e);

    if (onMessage) {
      onMessage(e);
    }
  };

  const { sendMessageToIframe } = useIframeMessage({
    iframeOrigin: getDocsConfig().miniDocsBaseURL,
    iframeRef,
    onMessageFromIframe
  });

  const {
    error,
    isIframeLoading,
    onIframeLoadEvent,
    onIframeLoadErrorEvent,
    onMessageFromIframe: onLoadingMessageFromIframe
  } = useDocsLoader({
    docLink: iframeSourceURL,
    sendMessageToIframe,
    onIframeLoadError,
    onIframeLoadSuccess,
    loadMessage,
    loadedMessage
  });

  return {
    error,
    iframeSourceURL,
    rebuildIframeSourceURL,
    isIframeLoading,
    onIframeLoadEvent,
    onIframeLoadErrorEvent,
    sendMessageToIframe
  };
}
